import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { DatabaseOutlined } from '@ant-design/icons';
import SheepAnimals from "./index";
import ViewSheep from "./view";
import EditSheep from "./edit";
import { MODULE_REG_SHEEP } from "variables/constants";

const sheepRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Sheeps",
		basePath: "registered-animals/sheeps",
		mainComponent: <SheepAnimals />,
	    layout: "/console",
		icon: <DatabaseOutlined className="h-6 w-6" />,
	    subTitle:"Sheep",
	    viewComponent: <ViewSheep />,
	    createComponent: <EditSheep />,
	    editComponent: <EditSheep />,
		modduleId: MODULE_REG_SHEEP,
	})
]

export default sheepRoutes;